import { useEffect } from 'react';

const HUB_URL = import.meta.env.VITE_HUB_URL ?? 'https://app.theonestack.com';

export default function LoginPage() {
  useEffect(() => {
    // Check for error param (failed SSO redirect)
    const params = new URLSearchParams(window.location.search);
    if (params.get('error')) return; // Show error, don't redirect
    // Redirect to Hub for centralized auth
    window.location.href = `${HUB_URL}/login?redirect=fleet`;
  }, []);

  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm text-center">
        <h1 className="text-2xl font-bold mb-4">The One Fleet</h1>
        {error ? (
          <>
            <p className="text-sm text-destructive mb-4">
              {error === 'invalid_token' && 'Invalid or expired login token.'}
              {error === 'token_used' && 'This login link has already been used.'}
              {error === 'no_account' && 'No Fleet account found for your email.'}
              {!['invalid_token', 'token_used', 'no_account'].includes(error) && 'Login failed.'}
            </p>
            <button
              onClick={() => { window.location.href = `${HUB_URL}/login?redirect=fleet`; }}
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              Try Again
            </button>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">Redirecting to The One Hub...</p>
        )}
      </div>
    </div>
  );
}
